import * as actionTypes from '../actions/actionTypes';

import { updateObject } from '../../shared/utility';
import { updateArray } from '../../shared/utility';

const initialState = {
	page: 'notOrder',
	category: 0,
	ingredients: {
		vegan: 0,
		toiletPaper: 0,
		maxiPad: 0,
		hotDog: 0,
		torta: 0,
		toast: 0,
		plain: 0,
		sesame: 0,

		mushrooms: 0,
		mitchMcConnell: 0,
		brownMeat: 0,
		redMeat: 0,
		crispyChimken: 0,
		freshChimken: 0,
		moreBun: 0,
		fisch: 0,

		cheese: 0,
		tomato: 0,
		lettuce: 0,
		onion: 0,
		bacon: 0,
		barnacles: 0,
		pennies: 0,
		flavorOfTheMonth: 0,

		veganTop: 0,
		toiletPaperTop: 0,
		maxiPadTop: 0,
		hotDogTop: 0,
		tortaTop: 0,
		toastTop: 0,
		plainTop: 0,
		sesameTop: 0,

		clownTears: 0,
		bloodDiamonds: 0,
		ketchup: 0,
		musturd: 0,
		periodtBlod: 0,
		sewage: 0,
		mayo: 0,
		bukkakeBrunch: 0,

		blank: 0,
	},
	FXPlaying: null,
	meme: {
		name1: 'McName yor',
		name2: 'churger, fuckface!',
		circ1: 'NEW',
		circ2_1: 'now only',
		circ2_2: '$69',
		circ3: 'i made this!',
		smolText:
			"Yeah, of course theres little shit here. Why the fuck do peolpe even like this shit? Make me squint my eyes and pinch my phone scrren. Shit's dumb.",
	},
	messages: [],
	drawer: false,
};

const setPage = (state, action) => {
	const updatedState = { page: action.page };
	return updateObject(state, updatedState);
};

const setCategory = (state, action) => {
	const updatedState = { category: action.category };
	return updateObject(state, updatedState);
};

const addIngredient = (state, action) => {
	const updatedIngredient = {
		[action.ingredientName]: state.ingredients[action.ingredientName] + 1,
	};
	const updatedIngredients = updateObject(state.ingredients, updatedIngredient);
	const updatedState = { ingredients: updatedIngredients };
	return updateObject(state, updatedState);
};
const removeIngredient = (state, action) => {
	const updatedIng = {
		[action.ingredientName]: state.ingredients[action.ingredientName] - 1,
	};
	const updatedIngs = updateObject(state.ingredients, updatedIng);
	const updatedState = { ingredients: updatedIngs };
	return updateObject(state, updatedState);
};
const setIngredient = (state, action) => {
	const updatedState = {
		ingredients: {
			vegan: action.ingredients.vegan,
			toiletPaper: action.ingredients.toiletPaper,
			maxiPad: action.ingredients.maxiPad,
			hotDog: action.ingredients.hotDog,
			torta: action.ingredients.torta,
			toast: action.ingredients.toast,
			plain: action.ingredients.plain,
			sesame: action.ingredients.sesame,

			mushrooms: action.ingredients.mushrooms,
			mitchMcConnell: action.ingredients.mitchMcConnell,
			brownMeat: action.ingredients.brownMeat,
			redMeat: action.ingredients.redMeat,
			crispyChimken: action.ingredients.dollarChimken,
			fisch: action.ingredients.fisch,
			freshChimken: action.ingredients.freshChimken,
			moreBun: action.ingredients.moreBun,

			cheese: action.ingredients.cheese,
			tomato: action.ingredients.tomato,
			lettuce: action.ingredients.lettuce,
			onion: action.ingredients.onion,
			bacon: action.ingredients.bacon,
			teeth: action.ingredients.teeth,
			barnacles: action.ingredients.barnacles,
			pennies: action.ingredients.pennies,
			flavorOfTheMonth: action.ingredients.flavorOfTheMonth,

			veganTop: action.ingredients.veganTop,
			toiletPaperTop: action.ingredients.toiletPaperTop,
			maxiPadTop: action.ingredients.maxiPadTop,
			hotDogTop: action.ingredients.hotDogTop,
			tortaTop: action.ingredients.tortaTop,
			toastTop: action.ingredients.toastTop,
			plainTop: action.ingredients.plainTop,
			sesameTop: action.ingredients.sesameTop,

			bloodDiamonds: action.ingredients.bloodDiamonds,
			ketchup: action.ingredients.ketchup,
			musturd: action.ingredients.musturd,
			periodtBlod: action.ingredients.periodtBlod,
			sewage: action.ingredients.sewage,
			mayo: action.ingredients.mayo,
			bukkakeBrunch: action.ingredients.bukkakeBrunch,
			clownTears: action.ingredients.clownTears,

			kitchenSink: action.ingredients.kitchenSink,
			cumRag: action.ingredients.cumRag,
			hearts: action.ingredients.hearts,
			dmt: action.ingredients.dmt,
			meth: action.ingredients.meth,
			moreMeth: action.ingredients.moreMeth,
			hydrogenDisulfide: action.ingredients.hydrogenDisulfide,
			spankings: action.ingredients.spankings,

			blank: action.ingredients.blank,
		},
	};
	return updateObject(state, { updatedState });
};

const setFXPlaying = (state, action) => {
	const updatedState = { FXPlaying: action.effect };
	return updateObject(state, updatedState);
};

const setMeme = (state, action) => {
	const updatedText = {
		[action.label]: action.text,
	};
	const updatedMeme = updateObject(state.meme, updatedText);
	const updatedState = { meme: updatedMeme };
	return updateObject(state, updatedState);
};

const setMessages = (state, action) => {
	const newMessage = {
		direction: action.direction,
		text: action.text,
	};
	const updatedMessages = updateArray([state.messages, newMessage]);
	const updatedState = { messages: updatedMessages };
	return updateObject(state, updatedState);
};

const setDrawer = (state, action) => {
	const updatedState = { drawer: action.bool };
	return updateObject(state, updatedState);
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.SET_PAGE:
			return setPage(state, action);
		case actionTypes.SET_CATEGORY:
			return setCategory(state, action);
		case actionTypes.ADD_INGREDIENT:
			return addIngredient(state, action);
		case actionTypes.REMOVE_INGREDIENT:
			return removeIngredient(state, action);
		case actionTypes.SET_INGREDIENTS:
			return setIngredient(state, action);
		case actionTypes.SET_FX_PLAYING:
			return setFXPlaying(state, action);
		case actionTypes.SET_MEME:
			return setMeme(state, action);
		case actionTypes.SET_MESSAGES:
			return setMessages(state, action);
		case actionTypes.SET_DRAWER:
			return setDrawer(state, action);
		default:
			return state;
	}
};

export default reducer;
